var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "404.000000pt",
    viewBox: "0 0 500.000000 404.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,404.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M796 3368 c-7 -13 -38 -148 -67 -300 -52 -271 -53 -277 -34 -297 18 -20 28 -21 397 -21 208 0 378 -2 378 -4 0 -2 -9 -48 -20 -102 -26 -132 -147 -754 -265 -1364 -52 -272 -100 -515 -106 -539 -8 -35 -7 -48 6 -67 l15 -24 340 0 c294 0 341 2 354 16 9 8 16 18 16 21 0 4 29 157 66 342 75 386 178 919 265 1366 33 171 63 320 66 332 5 23 6 23 246 25 l241 3 197 280 c109 154 198 290 198 302 1 12 -6 29 -15 37 -14 14 -131 16 -1139 16 l-1125 0 -14 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3524 3382 c-6 -4 -178 -233 -383 -509 l-372 -502 -160 -3 c-135 -2 -163 -6 -173 -19 -6 -9 -36 -141 -65 -293 -45 -226 -52 -280 -43 -301 l11 -25 183 -2 182 -3 171 -521 c94 -287 176 -529 184 -538 12 -14 53 -16 371 -16 333 0 358 1 373 18 10 10 17 24 17 30 0 6 -106 305 -235 665 -129 360 -235 660 -235 666 0 11 154 213 701 921 113 146 222 287 242 314 38 50 47 92 25 114 -9 9 -111 12 -397 12 -213 0 -391 -4 -397 -8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.5c3af01ad98e7d1edea735e6b8c713a5.svg";
export { ForwardRef as ReactComponent };